<ion-content class="permission-stepper__content" fullscreen>
  <div class="permission-stepper__container">
    <div class="permission-stepper__topbar">
      <ion-button fill="clear" size="small" class="back-button" (click)="close()">
        <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </div>

    <div class="permission-stepper__body" *ngIf="canShowStep">
      <div *ngIf="isFilteredMode" class="permission-stepper__mode-indicator">Étape rapide</div>

      <div
        class="permission-stepper__icon-wrap"
        [class.permission-stepper__icon-wrap--granted]="isAutoVerifiable(currentStep!.key) && permGranted(currentStep!.key)"
      >
        <ion-icon name="shield-checkmark-outline"></ion-icon>
      </div>

      <h2 class="permission-stepper__title">
        {{ currentStep!.titleKey | translate }}
      </h2>

      <p class="permission-stepper__description">
        {{
          currentStep!.key === "location"
            ? (locationStepDescription | translate)
            : (currentStep!.descriptionKey | translate)
        }}
      </p>

      <div class="permission-stepper__preview">
        <div class="permission-stepper__preview-row">
          <div class="permission-stepper__preview-app-icon">
            <img src="assets/icons/icon-128.webp" alt="Bob Express" />
          </div>
          <span class="permission-stepper__preview-app-name">Bob Express</span>
          <div
            class="permission-stepper__preview-toggle"
            [class.permission-stepper__preview-toggle--on]="isAutoVerifiable(currentStep!.key) && permGranted(currentStep!.key)"
          >
            <div class="permission-stepper__preview-thumb"></div>
          </div>
        </div>
      </div>

      <ion-button
        expand="block"
        class="permission-stepper__primary-button"
        [color]="isAutoVerifiable(currentStep!.key) && permGranted(currentStep!.key) ? 'success' : 'primary'"
        [disabled]="loading"
        (click)="requestCurrentPermission()"
      >
        {{ isAutoVerifiable(currentStep!.key) && permGranted(currentStep!.key) ? ("PERMISSIONS.STEPPER.DONE" | translate) : (currentStep!.actionKey | translate) }}
      </ion-button>

      <div class="permission-stepper__skip-row">
        <button type="button" class="permission-stepper__skip" (click)="skipCurrentStep()">
          {{ "PERMISSIONS.STEPPER.SKIP" | translate }}
        </button>
      </div>
    </div>
  </div>
</ion-content>
